import { render } from "./dzjy.vue?vue&type=template&id=bd5ba440&scoped=true&ts=true"
import script from "./dzjy.vue?vue&type=script&lang=ts"
export * from "./dzjy.vue?vue&type=script&lang=ts"

import "./dzjy.vue?vue&type=style&index=0&id=bd5ba440&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd5ba440"]])

export default __exports__